<template>
  <b-row>
    <b-row
      class="mx-lg-3 my-lg-0 mx-md-3 my-md-0 my-1"
      align-v="center"
      style="background-color:#7a7a7a;"
    >
      <b-col
        md="6"
        style="padding: 0px !important;"
      >
        <b-img
          :src="`${delivery}publico/paginas/inicio/comunidad-alumnos-campus-virtual-indetec.jpg`"
          fluid-grow
          alt="Comunidad alumnos campus virtual indetec"
        />
      </b-col>
      <b-col
        md="6"
        style="padding: 0px !important;"
      >
        <h3
          class="text-center m-3"
          style="color:white"
        >
          Estudiantes
        </h3>
        <p
          class="m-5 px-md-3 px-lg-5 text-justify"
          style="color:white"
        >
          Son funcionarios hacendarios en activo, con interés en continuar estudios de posgrado en temas vinculados con la Hacienda Pública.
        </p>
      </b-col>
    </b-row>
    <b-row
      class="mx-lg-3 my-lg-0 mx-md-3 my-md-0 my-1"
      align-v="center"
      style="background-color:#efede7"
    >
      <b-col
        md="6"
        style="padding: 0px !important;"
      >
        <h3
          class="text-center m-3"
        >Asesores</h3>
        <p class="m-5 px-md-3 px-lg-5 text-justify">
          Son colaboradores de INDETEC con amplia experiencia profesional y conocimientos en los temas hacendarios, proporcionan apoyo en los programas educativos a distancia en modalidad sin profesor. En este caso son responsables o colaboradores de asignatura.
        </p>
      </b-col>
      <b-col
        md="6"
        style="padding: 0px !important;"
      >
        <b-img
          :src="`${delivery}publico/paginas/inicio/comunidad-asesores-campus-virtual-indetec.jpg`"
          fluid-grow
          alt="Comunidad asesores campus virtual indetec"
        />
      </b-col>
    </b-row>
    <b-row
      class="mx-lg-3 my-lg-0 mx-md-3 my-md-0 my-1"
      align-v="center"
      style="background-color:#aa9d6b"
    >
      <b-col
        md="6"
        style="padding: 0px !important;"
      >
        <b-img
          :src="`${delivery}publico/paginas/inicio/comunidad-profesores-campus-virtual-indetec.jpg`"
          fluid-grow
          alt="Comunidad profesores campus virtual indetec"
        />
      </b-col>
      <b-col
        md="6"
        style="padding: 0px !important;"
      >
        <h3
          class="text-center m-3"
          style="color:white"
        >Profesores</h3>
        <p
          class="m-5 px-md-3 px-lg-5 text-justify"
          style="color:white"
        >
          Son colaboradores de INDETEC con amplia experiencia profesional, especializados en temas de la Hacienda Pública y con experiencia docente.
        </p>
      </b-col>
    </b-row>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BImg,
    BRow,
    BCol,
  },
  setup() {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    return {
      delivery,
    }
  },
}
</script>
